import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Helmet } from 'react-helmet';
export default function CutHome() {
  const navigate = useNavigate();
  const { wallet, setSideBarOpen } = useContext(Context);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isOpen && e.target.closest('.wrapper') === null) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isOpen]);

  useEffect(() => {
    setSideBarOpen(isOpen);
  }, [isOpen, setSideBarOpen]); // ✅ Added setSideBarOpen to dependencies

  return (
    <div className='content'>
      <Helmet>
        <title>Matka Cut</title>
        <meta name="description" content="Matka Gambling app user can cut a fix amount of money from each number if they want with help of this page ." />
      </Helmet>
      <div className={`wrapper ${isOpen ? '' : 'active'}`}>
        <div className="section">
          <div className="top_navbar">
            <div className="hamburger">
              <button className='back_btn' onClick={() => navigate(-1)} style={{ background: 'none', border: 'none' }}>
                <i className="fa-solid fa-chevron-left"></i>
              </button> {/* ✅ Changed <a> to <button> */}
            </div>
            <div className='gameName'>Jantri Cutting</div>
            <div>
              <i className="fa-solid fa-wallet" style={{ color: "white" }}></i>
              <span style={{ color: "white", textAlign: "center" }}>{wallet}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
